import { Box, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'

export const PlaceholderCard = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.SizingSpacing200,
    backgroundColor: tokens.ColorSurfaceDefault,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: tokens.SizingCornerL,
    padding: tokens.SizingSpacing200,
    minHeight: '220px',
    width: '100%',
    maxWidth: '840px',
}))
